/* @flow */
/* eslint no-unused-vars: 0 */

import React from 'react';
import SimpleAddToBasket from './simple_add_to_basket';

import StandardProduct from './standard_product';

class ProductListings extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formattedProperties: [],
      comparedProducts: [],
      addingToBasket: false,
    };

    this.addCompareProduct = this.addCompareProduct.bind(this);
    this.removeCompareProduct = this.removeCompareProduct.bind(this);
    this.viewProduct = this.viewProduct.bind(this);
    this.getPrice = this.getPrice.bind(this);
    this.getBranchStock = this.getBranchStock.bind(this);
    this.handleUnit = this.handleUnit.bind(this);
    this.lazyLoader = this.lazyLoader.bind(this);
    this.lazyLoadImage = this.lazyLoadImage.bind(this);
    this.isAddingToBasket = this.isAddingToBasket.bind(this);
  }

  componentDidMount() {
    PubSub.subscribe('PRODUCT-COMPARE-UPDATED', (msg, products) => {
      this.setState({
        comparedProducts: products,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      formattedProperties: this.chunkProperties(nextProps.products, 3),
    });
  }

  componentDidUpdate() {
    const { allImages } = this.props;

    const options = {
      rootMargin: '15px',
      threshold: 0.5,
    };

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        this.lazyLoader.bind(this),
        options,
      );

      [...allImages].forEach(image => {
        this.observer.observe(image);
      });
    } else {
      const images = Array.prototype.slice.call(allImages, 0);
      const _this = this;
      // nodes is an array now.
      images.forEach(function (image) {
        _this.lazyLoadImage(image);
      });
    }
  }

  chunkProperties(arr, n) {
    return arr
      .slice(0, ((arr.length + n - 1) / n) | 0)
      .map((c, i) => arr.slice(n * i, n * i + n));
  }

  addCompareProduct(product) {
    $.ajax({
      url: '/products_compare',
      data: {
        product_id: product,
      },
      method: 'POST',
      dataType: 'JSON',
      success: () => {
        PubSub.publish('PRODUCT-COMPARE-ADDED', '');
      },
      error: () => {},
    });
  }

  handleUnit(unit) {
    let value;

    switch (unit) {
      case 'm':
      case 'kg':
        value = unit;
        break;
      case 'each':
      case 'Each':
        value = '';
        break;
      default:
        value = ` ${unit}`;
    }

    return value;
  }

  getPrice(id) {
    const { prices } = this.props;

    let price;

    if (prices !== null) {
      price = prices[id];
    }

    return price !== undefined ? (
      <div>
        <div
          className="price-inc-moq"
          data-price={
            this.props.vat_exclusive == true
              ? price.price.toFixed(2)
              : price.price_inclusive.toFixed(2)
          }>
          <span className="price">
            £
            {this.props.vat_exclusive == true
              ? price.price.toFixed(2)
              : price.price_inclusive.toFixed(2)}{' '}
          </span>

          <span className="moq">
            For {price.quantity}
            {this.handleUnit(price.unit)}
          </span>
        </div>
        <div className="vat-switch">
          {this.props.vat_exclusive == true ? (
            <span>£{price.price_inclusive.toFixed(2)} inc VAT</span>
          ) : (
            <span>£{price.price.toFixed(2)} ex VAT</span>
          )}
        </div>
        <div className="product-price-breaks">
          {price.breaks.data.map((b, index) => {
            const breakLength = price.breaks.data.length;
            if (breakLength - 1 === index) {
              return (
                <div className="basket-price-break" key={index}>
                  <div className="basket-price-break__title caps">
                    <div>
                      <span className="price-break__per-pack">
                        {b.per_pack}
                      </span>
                      <span className="price-break__price">
                        £
                        {this.props.vat_exclusive == true
                          ? b.per_price.toFixed(2)
                          : b.per_price_inclusive.toFixed(2)}
                        &nbsp;for&nbsp;
                        {price.per_pack}
                        {this.handleUnit(price.unit)}
                      </span>
                    </div>
                    <div>
                      <span className="price-break__saving">
                        Saving {price.breaks.saving}
                      </span>
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    ) : (
      ''
    );
  }

  getDeliveryStock(id) {
    if (this.props.products) {
      const stock = this.props.products.filter(stock => stock.id === id)[0]
        .b2b_stock_level;
      return stock;
    }
  }

  getBranchStock(id) {
    if (this.props.branchStocks) {
      const stock = this.props.branchStocks.filter(
        stock => stock.product_id == id,
      )[0];
      return stock !== undefined ? parseInt(stock.stock) : 0;
    }
  }

  removeCompareProduct(product) {
    $.ajax({
      url: '/products_compare',
      data: {
        product_id: product,
      },
      method: 'DELETE',
      dataType: 'JSON',
      success: products => {
        PubSub.publish('PRODUCT-COMPARE-ADDED');
      },
      error: () => {
        this.setState({
          error: true,
        });
      },
    });
  }

  viewProduct(url) {
    location.href = url;
  }

  lazyLoader(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        this.lazyLoadImage(entry.target);
      }
    });
  }

  lazyLoadImage(observedImage) {
    observedImage.classList.remove('image__list-lazy-image');

    if (observedImage.getAttribute('data-src')) {
      observedImage.src = observedImage.dataset.src;
      observedImage
        .closest('.product--listings_product')
        .classList.remove('loading');

      if ('IntersectionObserver' in window) {
        this.observer.unobserve(observedImage);
      }
    }
  }

  isAddingToBasket() {
    const { addingToBasket } = this.state;

    this.setState({
      addingToBasket: !addingToBasket,
    });
  }

  render() {
    const { icons } = this.props.assets;

    return (
      <div className="product-listings-wrapper">
        {this.state.formattedProperties.map((products, index) => {
          return (
            <div key={index} className="row-fluid">
              {products.map((product, index) => {
                const { trade_essentials: tradeEssentials } = product;
                const compare = this.state.comparedProducts.some(prod => {
                  return prod.id === product.id;
                }) ? (
                  <div
                    className="product--compare hidden-phone"
                    onClick={() => {
                      this.removeCompareProduct(product.id);
                    }}>
                    <img src={icons.checked} alt="" height={14} width={14} />
                    <span>Compare</span>
                  </div>
                ) : (
                  <div
                    className={`product--compare hidden-phone ${
                      this.state.comparedProducts.length === 3 ? 'inactive' : ''
                    }`}
                    onClick={() => {
                      this.addCompareProduct(product.id);
                    }}>
                    <img src={icons.unchecked} alt="" height={14} width={14} />
                    <span>Compare</span>
                  </div>
                );
                const addToBasket = (
                  <SimpleAddToBasket
                    productStepId={product.id}
                    collectionOnly={product.collection_only}
                    prodMinOrder={product.minimum_order}
                    prodDeliveryMinOrder={product.delivery_minimum_order}
                    prodMaxQuant={product.maximum_quantity}
                    addValue="Add to Basket"
                    url="/basket"
                    isAddingToBasket={this.isAddingToBasket}
                    addingToBasket={this.state.addingToBasket}
                    stockLevel={this.getDeliveryStock(product.id)}
                  />
                );
                return (
                  <StandardProduct
                    selectAStoreUrl={this.props.selectAStoreUrl}
                    currentStore={this.props.currentStore}
                    key={product.id}
                    product={product}
                    tradeEssentials={tradeEssentials}
                    icons={icons}
                    addToBasket={addToBasket}
                    compare={compare}
                    index={index}
                    viewProduct={this.viewProduct}
                    loadingPrices={this.props.loadingPrices}
                    getPrice={this.getPrice}
                    branchStocks={this.props.branchStocks}
                    collectionSet={this.props.collectionSet}
                    getBranchStock={this.getBranchStock}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

export default ProductListings;
